import React, { useState, useEffect, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../Utilities";
import HelpButton from "../../HelpButton";
import ApplicationButton from "../ApplicationButton";
import AutoCompleteWrapper from "./special-component/AutoCompleteWrapper";

import "./FibAutoComplete.css";

const multipleFieldsClick = (e, fields) => {
  let fieldsWithValues = [];
  let fieldName, selectedItem;
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i]; // Store reference in constant (so do not get get warnings about using fields[i])
    if (field.datatype !== "note") {
      fieldName = field.variable_name;
      const selectedValue = document.querySelector(
        `#${fieldName} > input`,
      ).value;
      selectedItem = field.choices.find((item) => item.label === selectedValue);
      fieldsWithValues[i] = {
        name: fieldName,
        value: selectedItem.value,
      };
    }
  }
  return fieldsWithValues;
};

const validateFields = (e, fields) => {
  let fieldName, selectedValue;
  for (let i = 0; i < fields.length; i++) {
    if (typeof fields[i].variable_name !== "undefined") {
      fieldName = fields[i].variable_name;
      selectedValue = document.querySelector(`#${fieldName} > input`).value;
      if (selectedValue === "") {
        try {
          document.getElementById(fieldName).classList.add("need-to-fill-in");
        } catch (e) {}
        return false;
      } else {
        try {
          document
            .getElementById(fieldName)
            .classList.remove("need-to-fill-in");
        } catch (e) {}
      }
    }
  }
  return true;
};

const getDefault = (field) => {
  for (let i = 0; i < field.choices.length; i++) {
    if (field.choices[i].default) {
      return field.choices[i].value;
    }
    return "";
  }
};

const initializeDropdowns = (fields) => {
  let dependencies = [];
  for (let i = 0; i < fields.length; i++) {
    let items = [];
    if (typeof fields[i].choices !== "undefined") {
      fields[i].choices.forEach((item) => {
        if (item.value !== "select-title" && item.value !== "dependent-on") {
          items.push({ label: item.label, value: item.value });
        }
      });
    }
    dependencies[i] = items;
  }
  return dependencies;
};

// /* application specific */
// if (fieldName === "ask_visa_type") {
//   if (fieldValue === "holds" {
//     const dependency[dependentFieldIndex] = [
//         { label: "Temporary Partner (subclass 820)", value: "820" },
//         { label: "Provisional Partner (subclass 309)", value: "309" },
//         { label: "Prospective Marriage (subclass 300)", value: "300" },
//         { label: "Permanent Partner visa (subclass 801)", value: "801" },
//       ];
//     }

//   if (fieldValue === "applied" {
//     const dependency[dependentFieldIndex] = [
//         { label: "Temporary Partner (subclass 820)", value: "820" },
//         { label: "Provisional Partner (subclass 309)", value: "309" },
//         { label: "Prospective Marriage (subclass 300)", value: "300" },
//         { label: "Permanent Partner visa (subclass 801)", value: "801" },
//       ];
//     }

//   if (fieldValue === "parent" {
//     const dependency[dependentFieldIndex] = [
//         { label: "Dependent Child (subclass 445)", value: "445" },
//       ];
//     }

//   if (fieldValue === "secondary" {
//     const dependency[dependentFieldIndex] = [
//         { label: "Business Talent (subclass 132)", value: "132" },
//         { label: "Employer Nomination Scheme (subclass 186)", value: "186" },
//         { label: "Regional Sponsored Migration Scheme (subclass 187)", value: "187" },
//         { label: "Skilled - Independent (subclass 189)", value: "189" },
//         { label: "Skilled - Nominated (subclass 190)", value: "190" },
//       ];
//     }
// };
//   }
// };

const FibAutoComplete = (props) => {
  const lang = getCookie("DA-language");
  // eslint-disable-next-line
  const { t, i18n } = useTranslation();
  const translate = i18n.getFixedT(lang);
  const [scriptElement, setScriptElement] = useState(null);
  // console.log("props.interview.fields = ", props.interview.fields);
  const [dependencies, setDependencies] = useState([]);

  useEffect(() => {
    // initialize dropdowns for input fields
    const dropdowns = initializeDropdowns(props.interview.fields);
    // console.log(dropdowns);
    setDependencies(dropdowns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof props.interview.script !== "undefined") {
      const newElement = document.createElement("script");
      setScriptElement(newElement);
      const inlineCode = document.createTextNode(props.interview.script);
      newElement.appendChild(inlineCode);
      document.body.appendChild(newElement);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.interview.script]);

  useLayoutEffect(() => {
    if (scriptElement !== null) {
      document.body.removeChild(scriptElement);
      setScriptElement(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.interview.script]);

  const handleDependencyChange = (event, field, fields) => {
    // console.log("handleDependencyChange");
    // console.log("event = ", event);
    // console.log("event.value.value = ", event.value.value);
    // console.log("event.value.label = ", event.value.label);

    const fieldName = field.variable_name;
    // console.log("fieldName = ", fieldName);
    let fieldValue;
    try {
      fieldValue = event.value.value;
      // console.log("fieldValue = ", fieldValue);
    } catch (e) {}

    const dependentOnFieldName = field.choices[1].label;
    // console.log("dependentOnFieldName = ", dependentOnFieldName);
    // console.log("field = ", field);

    const dependentOnFieldValue = document.querySelector(
      `#${dependentOnFieldName} input`,
    ).value;
    // console.log("dependentOnFieldValue = ", dependentOnFieldValue);

    const dependentFieldIndex = fields.findIndex(
      (obj) => obj.variable_name === dependentOnFieldName,
    );
    // console.log("dependentFieldIndex = ", dependentFieldIndex);
    // const dependentOnField = fields[dependentFieldIndex];
    // console.log("dependentOnField = ", dependentOnField);

    let dropdowns;
    if (
      (typeof fieldValue === "undefined" || fieldValue === "") &&
      (typeof dependentOnFieldValue === "undefined" ||
        dependentOnFieldValue === "")
    ) {
      dropdowns = initializeDropdowns(fields);
      // document.querySelector("#ask_visa_type input").value = "";
    } else {
      dropdowns = [...dependencies];
    }

    /* Application-specific processing */
    if (
      typeof fieldValue !== "undefined" &&
      fieldValue !== null &&
      fieldValue !== ""
    ) {
      if (fieldName === "ask_visa_type") {
        if (fieldValue === "holds") {
          dropdowns[dependentFieldIndex] = [
            /* Prospective partner visas */
            { label: "Temporary Partner (subclass 820)", value: "820" },
            { label: "Provisional Partner (subclass 309)", value: "309" },
            { label: "Prospective Marriage (subclass 300)", value: "300" },
            /* Permanent partner visa */
            { label: "Permanent Partner (subclass 801)", value: "801" },
            /* Some other type of visa */
            { label: "Some other type of", value: "999" },
          ];
        }

        if (fieldValue === "applied") {
          dropdowns[dependentFieldIndex] = [
            /* Prospective partner visas */
            { label: "Temporary Partner (subclass 820)", value: "820" },
            { label: "Provisional Partner (subclass 309)", value: "309" },
            { label: "Prospective Marriage (subclass 300)", value: "300" },
            /* Permanent partner visa */
            { label: "Permanent Partner (subclass 801)", value: "801" },
            /* Some other type of visa */
            { label: "Some other type of", value: "999" },
          ];
        }

        if (fieldValue === "parent") {
          dropdowns[dependentFieldIndex] = [
            /* Dependent child visa */
            { label: "Dependent Child (subclass 445)", value: "445" },
            /* Some other type of visa */
            { label: "Some other type of", value: "999" },
          ];
        }

        if (fieldValue === "secondary") {
          dropdowns[dependentFieldIndex] = [
            /* Skilled and Business visas */
            { label: "Business Talent (subclass 132)", value: "132" },
            {
              label: "Employer Nomination Scheme (subclass 186)",
              value: "186",
            },
            {
              label: "Regional Sponsored Migration Scheme (subclass 187)",
              value: "187",
            },
            { label: "Skilled - Independent (subclass 189)", value: "189" },
            { label: "Skilled - Nominated (subclass 190)", value: "190" },
            {
              label: "Permanent Residence (Skilled Regional) (subclass 191)",
              value: "191",
            },
            { label: "Pacific Engagement (subclass 192)", value: "192" },
            { label: "Global Talent (subclass 858)", value: "858old" },
            { label: "National Innovation (subclass 858)", value: "858" },
            { label: "Skilled - Regional (subclass 887)", value: "887" },
            {
              label: "Business Innovation and Investment (subclass 888)",
              value: "888",
            },
            /* Family visas */
            { label: "Parent (subclass 103)", value: "103" },
            { label: "Remaining Relative (subclass 115)", value: "115" },
            { label: "Carer (subclass 116)", value: "116" },
            { label: "Contributory Parent (subclass 143)", value: "143" },
            { label: "Aged Parent (subclass 804)", value: "804" },
            { label: "Remaining Relative (subclass 835)", value: "835" },
            { label: "Carer (subclass 836)", value: "836" },
            { label: "Contributory Parent (subclass 864)", value: "864" },
            /* Some other type of visa */
            { label: "Some other type of", value: "999" },
          ];
        }
      }

      if (fieldName === "visa_subclass") {
        /* Prospective partner visas and permanent partner visa */
        if (["820", "309", "300", "801"].includes(fieldValue)) {
          dropdowns[dependentFieldIndex] = [
            { label: "holds", value: "holds" },
            { label: "has applied for", value: "applied" },
          ];
        }

        /* Dependent child visa */
        if (fieldValue === "445") {
          dropdowns[dependentFieldIndex] = [
            { label: "is a parent of a child who holds", value: "parent" },
          ];
        }

        /* Skilled and Business visas */
        if (
          [
            "132",
            "186",
            "187",
            "189",
            "190",
            "191",
            "192",
            "858old",
            "858",
            "887",
            "888",
          ].includes(fieldValue)
        ) {
          dropdowns[dependentFieldIndex] = [
            { label: "is a secondary applicant on", value: "secondary" },
          ];
        }

        /* Family visas */
        if (
          ["103", "115", "116", "143", "804", "835", "836", "864"].includes(
            fieldValue,
          )
        ) {
          dropdowns[dependentFieldIndex] = [
            { label: "is a secondary applicant on", value: "secondary" },
          ];
        }

        /* Some other type of visa */
        if (fieldValue === "999") {
          dropdowns[dependentFieldIndex] = [
            { label: "holds", value: "holds" },
            { label: "has applied for", value: "applied" },
            { label: "is a parent of a child who holds", value: "parent" },
            { label: "is a secondary applicant on", value: "secondary" },
          ];
        }
      }
    } else {
      // If visa_subclass field is empty, reset the dropdown for the ask_visa_type
      // field to include all possible values
      if (fieldName === "visa_subclass") {
        dropdowns[dependentFieldIndex] = [
          { label: "holds", value: "holds" },
          { label: "has applied for", value: "applied" },
          { label: "is a parent of a child who holds", value: "parent" },
          { label: "is a secondary applicant on", value: "secondary" },
        ];
      }
    }
    // console.log("dropdowns =", dropdowns);
    setDependencies(dropdowns);

    if (dropdowns[dependentFieldIndex].length === 1) {
      document.querySelector(`#${dependentOnFieldName} input`).value =
        dropdowns[dependentFieldIndex][0].label;
    }
  };

  return (
    <>
      {/* Interview Header */}
      <h1 className="interview-h1 text-lg lg:text-2xl xl:text-3xl font-bold text-brandCharcoal">
        {props.interview.questionText}
      </h1>

      <div className="pt-2 fill-in-the-blanks">
        {/* Fill in the blanks panel, with drop down fields */}
        {props.interview.fields &&
          props.interview.fields.length > 0 &&
          props.interview.fields[0].choices &&
          props.interview.fields[0].choices.length > 0 &&
          props.interview.fields.map((interviewObj, interviewObjIndex) => {
            if (interviewObj.datatype === "note") {
              return (
                <div
                  key={interviewObjIndex}
                  className="fitb-note"
                  dangerouslySetInnerHTML={{ __html: interviewObj.note }}
                />
              );
            } else {
              // console.log("rendering FibAutoComplete...");
              // console.log("dependencies =", dependencies);
              return (
                <label key={interviewObjIndex}>
                  <div
                    className="fitb-label"
                    dangerouslySetInnerHTML={{ __html: interviewObj.label }}
                  />

                  <AutoCompleteWrapper
                    index={interviewObjIndex}
                    isLoadedInApp={props.isLoadedInApp}
                    showButtonSpinner={props.showButtonSpinner}
                    interview={props.interview}
                    choices={dependencies[interviewObjIndex]}
                    onChange={(e, field) =>
                      handleDependencyChange(
                        e,
                        props.interview.fields[interviewObjIndex],
                        props.interview.fields,
                      )
                    }
                    sessionID={props.sessionID}
                    Click={props.handleClick}
                    goPrevQuestion={props.goPrevQuestion}
                    restartInterview={props.restartInterview}
                  />
                </label>
              );
            }
          })}
      </div>

      {/* {selectedItem && (
        <div className="mt-6 p-4 bg-blue-50 rounded-md">
          <h2 className="text-sm font-semibold text-gray-700 mb-2">
            Selected Item:
          </h2>
          <p className="text-gray-800">
            <span className="font-medium">Label:</span> {selectedItem.label}
          </p>
          <p className="text-gray-800">
            <span className="font-medium">Value:</span> {selectedItem.value}
          </p>
        </div>
      )}*/}

      {/* "Submit" Button */}
      <div className="pt-6">
        <div>
          <ApplicationButton
            key={0}
            index={0}
            id="multiple-fields-submit"
            name={
              props.interview.fields[0].variable_name ||
              props.interview.fields[0].choices.variable_name
            }
            label={translate("continue-txt")}
            value={getDefault(props.interview.fields[0])}
            buttonColor=""
            handleClick={(e) => {
              if (validateFields(e, props.interview.fields)) {
                props.handleClick(
                  e,
                  multipleFieldsClick(e, props.interview.fields),
                );
              }
            }}
            isLoadedInApp={props.isLoadedInApp}
            showButtonSpinner={true}
          />

          {/* Help Button */}
          {props.interview.help &&
            props.interview.help.label &&
            props.interview.help.label.length > 0 && (
              <HelpButton
                isLoadedInApp={props.isLoadedInApp}
                buttonKey={props.interview.fields[0].choices.length}
                help={props.interview.help}
                helpText={props.interview.helpText}
              />
            )}
        </div>
      </div>
    </>
  );
};

export default FibAutoComplete;
